import React, { Fragment, useCallback, useEffect } from "react";
import { Spin, Typography } from "antd";
import { loadHome } from "../../../application/home-slice";
import { useAppDispatch, useAppSelector } from "../../../application/store";
import { DocumentTitle } from "../../components";
import ReactImageGallery from "react-image-gallery";
import { isMobile } from "react-device-detect";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import ScrollBar from "./components/ScrollBar";

export default function Home() {
  const dispatch = useAppDispatch();
  const { loading, sections, slider } = useAppSelector((state) => state.home);
  const { width } = useWindowDimensions();

  const stableDispatch = useCallback(dispatch, []);
  useEffect(() => {
    if (loading === "idle") stableDispatch(loadHome());
  }, [loading, stableDispatch]);

  const reactGalleryItems = slider?.map((image) => {
    return {
      original: image.image,
      renderItem: (item: any) => {
        return (
          <a href={image.link}>
            <img
              style={{ objectFit: "cover" }}
              src={item.original}
              alt={image.link}
              width="100%"
              height={
                isMobile
                  ? (450 / 880) * width
                  : width > 1366
                  ? (450 / 1350) * 1366
                  : (450 / 1350) * width
              }
            />
          </a>
        );
      },
    };
  });

  const isLoading = loading === "pending";
  return (
    <Spin spinning={isLoading}>
      <div style={isLoading ? { minHeight: 600 } : {}}>
        <DocumentTitle title={undefined}>
          <div style={{ padding: 16 }}>
            <ReactImageGallery
              items={reactGalleryItems === undefined ? [] : reactGalleryItems}
              infinite
              showNav={false}
              showFullscreenButton={false}
              showThumbnails={false}
              showPlayButton={false}
              showBullets
              isRTL
              autoPlay
              slideInterval={3000}
            />
          </div>
          {sections.map((section) => {
            if (section.isActive === false) return <Fragment />;
            if (section.type === "Scroll")
              return <ScrollBar section={section} />;
            return (
              <div style={{ padding: 8 }}>
                {section.title !== null && section.description !== null ? (
                  <Fragment>
                    <Typography.Title level={4} style={{ padding: 8 }}>
                      {section.title}
                    </Typography.Title>
                    <Typography.Paragraph style={{ padding: 8 }}>
                      {section.description}
                    </Typography.Paragraph>
                  </Fragment>
                ) : (
                  <Fragment />
                )}
                <div
                  style={{ width: "100%", overflow: "hidden", lineHeight: 0 }}
                >
                  {section.images.map((image, index) => {
                    return (
                      <div
                        style={{
                          display: "inline-block",
                          width: isMobile
                            ? section.type === "4Image"
                              ? "50%"
                              : "100%"
                            : section.type === "4Image"
                            ? "25%"
                            : "50%",
                          paddingLeft:
                            section.type === "2Image" && !isMobile
                              ? index % 2 === 0
                                ? 10
                                : 0
                              : 0,
                          paddingRight:
                            section.type === "2Image" && !isMobile
                              ? index % 2 === 1
                                ? 10
                                : 0
                              : 0,
                          padding: 8,
                        }}
                      >
                        <div
                          style={{
                            position: "relative",
                            paddingBottom:
                              section.type === "4Image" ? "75%" : "37.5%",
                          }}
                        >
                          <div style={{ position: "absolute" }}>
                            <a href={image.link}>
                              <img
                                src={image.image}
                                alt={image.link}
                                width="100%"
                              />
                            </a>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </DocumentTitle>
      </div>
    </Spin>
  );
}
